import React from 'react'
import PropTypes from 'prop-types'
import Badge from '../Badge'
import Counter from '../Counter'

/**
 * Circle badge to display numbers.
 */
const CounterBadge = ({ count, truncate, ...badgeProps }) => {
  return <Badge visible={count > 0} content={<Counter count={count} truncate={truncate} />} {...badgeProps} />
}

CounterBadge.defaultProps = {
  count: 0,
  truncate: false,
}

CounterBadge.propTypes = {
  /**
   * The number displayed in the badge.
   */
  count: PropTypes.number,

  /**
   * Whether the badge content number should be truncated if greater than 9 (displays `9+`)
   */
  truncate: PropTypes.bool,
}

export default CounterBadge
